import axios from 'axios';
import { req, rawreq, csreq, csrawreq, reqFormData } from './axiosFun';

// 学员数据 列表
export const queryStudentList = (params) => {
  return req("post", "/api/student/queryStudentList", params)
};

// 学员数据 新增
export const saveStudent = (params) => {
  return req("post", "/api/class/savaStudent", params)
};

// 学员数据 修改
export const updateStudent = (params) => {
  return req("post", "/api/student/updateStudent", params)
};

// 学员数据 修改
export const updateKscj = (params) => {
  return req("post", "/api/student/updateKscj", params)
};

// 学员数据 删除
export const deleteStudentById = (params) => {
  return req("get", "/api/student/deleteStudentById?id=" + params.id + "&bjbId=" + params.bjbId , {})
};

// 学员数据 详情
export const queryStudentDetail = (params) => {
  return req("post", "/api/student/queryStudentDetail", params)
};

// 学员数据 换班
export const changeClass = (params) => {
  return req("post", "/api/student/changeClass", params)
};

// 学员数据 作废
export const cancelStu = (params) => {
  return req("post", "/api/student/cancel", params)
};

// 学员数据 审核
export const approve = (params) => {
  return req("post", "/api/student/approve", params)
};

// 获取 地区数据
export const queryAllArea = (params) => {
  return req("post", "/api/common/queryAllArea", params)
};

// 获取 学历数据
export const queryEdu = (params) => {
  return req("post", "/api/common/queryEdu", params)
};

// 获取 附件类型
export const queryAttach = (params) => {
  return req("post", "/api/common/queryAttach", params)
};


// 根据学员id 获取所有附件
export const queryListByStuId = (params) => {
  return req("post", "/api/studentAttach/queryListByStuId", params)
};
// 根据学员id 获取所有历史证书
export const queryCert = (params) => {
  return req("post", "/api/class/queryCert", params)
};
// 删除历史证书
export const deleteCert = (params) => {
  return req("post", "/api/class/deleteCert", params)
};
// 根据复训科目id 获取历史证书
export const queryCertificate = (params) => {
  return req("post", "/api/common/queryCertificate", params)
};
// 保存历史证书
export const saveCert = (params) => {
  return req("post", "/api/class/saveCert", params)
};


// 学员附件保存接口
export const saveFile = (params) => {
  return req("post", "/api/studentAttach/save", params)
};

// 学员附件 修改附件信息
export const updateFile = (params) => {
  return req("post", "/api/studentAttach/update", params)
};

// 学员附件 删除附件信息
export const deleteFile = (params) => {
  return req("post", "/api/studentAttach/delete", params)
};


/*
*   学员导入导出
* */
// 下载导入模板
export const downloadStudentTemplate = (params) => {
  return csreq("post", "/api/export/downloadStudentTemplate", params)
};
// 导入 学员数据
export const importStudent = (params) => {
  return reqFormData("post", "/api/import/importStudent", params)
};
// 导入 学员图片数据
export const importStudentImgByType = (params) => {
  return reqFormData("post", "/api/import/importStudentImgByType", params)
};

// 导出学员学历证明zip包
export const educationCertificateZip = (params) => {
  return csreq("post", "/api/export/educationCertificateZip", params)
};
// 导出学员身份证zip包
export const idCardImgZip = (params) => {
  return csreq("post", "/api/export/idCardImgZip", params)
};
// 导出学员头像zip包
export const photoZip = (params) => {
  return csreq("post", "/api/export/photoZip", params)
};

// 导出 学生图片数据
export const exportStudentImgByType = (params) => {
  return csrawreq("post", "/api/export/exportStudentImgByType", params)
};
// 导出学生花名册数据
export const exportStudent = (params) => {
  return csrawreq("post", "/api/export/exportStudent", params)
};


// 下载 学员
export const dcStudentByClassId = (params) => {
  return csreq("post", "/api/class/dcStudentByClassId", params)
};


// 测试302错误，返回登录页
export const testlogin = (params) => {
  return req("get", "/api/testLogin", params)
};


// 通过学员id获取全部模拟情况
export const queryTestListById = (params) => {
  return req("get", "/api/student/queryTestListById?studentId=" + params , '')
};
// 通过userId 和 paperName 获取全部模拟情况
export const queryPaper = (params) => {
  return rawreq("post", "/api/student/queryPaper", params)
};
// 发卡（可以多选）
export const sendCard = (params) => {
  return req("get", "/api/student/sendCard?studentId=" + params.studentId + '&bjbId=' + params.bjId , '')
};

// 下载导入模板
export const downloadTemp = (params) => {
  return csreq("POST", "/api/class/downloadTemp", params)
};
// 导入--数据有问题会返回一个错误的Excel
export const uploadStudent = (params) => {
  return req("POST", "/api/class/upload", params)
};



// WEBPACK FOOTER //
// ./src/api/student.js